/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./weixinAuthorizeUserInfoMask.vue?vue&type=template&id=378e9298"
import script from "./weixinAuthorizeUserInfoMask.vue?vue&type=script&lang=js"
export * from "./weixinAuthorizeUserInfoMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports